
import { Component, OnInit, OnDestroy, ViewChild, HostListener, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subscription, Observable } from 'rxjs';
import { NumberKeypadComponent } from 'src/app/partsCommon/number-keypad/number-keypad.component';
import { ItemSelectSimpleCondition } from 'src/app/partsCommon/item-select-simple/item-select-simple.component';
import { SectionHeaderComponent } from 'src/app/partsCommon/section-header/section-header.component';
import { CommonService } from 'src/app/service/common.service';
import { HttpBasicService } from 'src/app/service/http-basic.service';
import { ReqDeleteItemLimitParamRec, ReqGetItemLimitParamListRec, ReqGetItemLimitParamRec, ReqUpdateItemLimitParamRec, RspDeleteItemLimitParamRec, RspGetItemLimitParamListRec, RspGetItemLimitParamRec, RspUpdateItemLimitParamRec, UpdateItemLimitParamRecDto } from 'src/app/webservice/item-param-limit';
import { ItemLimitParamListRec } from '../0_def/item-limit-param-list-rec';
import { TableColumnDef } from 'src/app/common/table-column-def';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { StoreGroupTypeRec } from 'src/app/common/store-group-type-rec';
import { StoreGroupNameRec } from 'src/app/common/store-group-name-rec';
import { RspGetStoreGroupType } from 'src/app/response/rsp-get-store-group-type';
import { RspGetStoreGroupName } from 'src/app/response/rsp-get-store-group-name';
import { StoreGroupStoreRec } from 'src/app/common/store-group-store-rec';
import { ReqGetStoreGroupStores, RspGetStoreGroupStores } from 'src/app/webservice/store-group';
import { ItemLimitParamRec } from '../0_def/item-limit-param-rec';

@Component({
  selector: 'app-all-store-param-item-limit',
  templateUrl: './all-store-param-item-limit.component.html',
  styleUrls: ['./all-store-param-item-limit.component.css']
})
export class AllStoreParamItemLimitComponent implements OnInit, OnDestroy {

  public orderStopSelList: any[];
  public itemSelectSimpleCondition: ItemSelectSimpleCondition = new ItemSelectSimpleCondition(this.fb);

  public itemLimitParamList: ItemLimitParamListRec[] = [];
  // public itemLimitParamListFiltered: ItemLimitParamListRec[] = [];
  public itemLimitParamListShow: ItemLimitParamListRec[] = [];
  public recordCount: number = 0;
  public displayColumnIds: string[] = ["delBtn", "itemCd", "itemName", "standard"];
  public columnDefs: TableColumnDef[] = [
    // { columnId: "itemCd",   header: "商品コード", width: 95, align:"center"},
    { columnId: "itemName", header: "商品名", width: 300 },
    { columnId: "standard", header: "規格", width: 150 },
    { columnId: "ctg0",     header: this.commonService.literal.ctg0Name, width: 200 },
    { columnId: "ctg1",     header: this.commonService.literal.ctg1Name, width: 200 },
    { columnId: "ctg2",     header: this.commonService.literal.ctg2Name, width: 200 },
    { columnId: "ctg3",     header: this.commonService.literal.ctg3Name, width: 200 }
  ];
  public formOnlyLimitParamItem: FormControl = new FormControl(false);
  public orderStopFlagValues: number[];

  public itemSelected: ItemLimitParamListRec;
  public formStoreGroupType: FormControl = new FormControl("");
  public formStoreGroupName: FormControl = new FormControl("");
  public storeGroupTypes: StoreGroupTypeRec[] = [];
  public storeGroupNames: StoreGroupNameRec[] = [];
  public storeGroupStores: StoreGroupStoreRec[];

  public itemList: ItemLimitParamRec[] = [];
  public itemListFiltered: ItemLimitParamRec[] = [];
  public itemListRecordCount: number = 0;
  public displayColumnIdsParam: string[] = [
    "storeCdName", "orderStopFlagName",
    "minZai", "minZaiLim",
    "maxZai", "maxZaiLim",
    "minStockDays", "minStockDaysLim",
    "maxStockDays", "maxStockDaysLim",
    "dateBegin", "dateEnd",
    "errBtn"
  ];
  public columnDefsParam: TableColumnDef[] = [
    { columnId: "storeCdName", header: "店舗", width: 100 },
    { columnId: "orderStopFlagName", header: "発注対象", width: 75, align: "center" },
    { columnId: "minZai", header: "最低陳列<br>(元)", width: 60, align: "right" },
    { columnId: "maxZai", header: "最大陳列<br>(元)", width: 60, align: "right" },
    { columnId: "minStockDays", header: "最低在庫<br>日数(元)", width: 60, align: "right" },
    { columnId: "maxStockDays", header: "最大在庫<br>日数(元)", width: 60, align: "right" },
  ];
  public minDate: Date;
  public changeMap: Map<string, ItemLimitParamRec> = new Map<string, ItemLimitParamRec>();
  public updMap: Map<string, ItemLimitParamRec> = new Map<string, ItemLimitParamRec>();
  public errorMap: Map<string, ItemLimitParamRec> = new Map<string, ItemLimitParamRec>();

  public minZaiForm: FormControl = new FormControl("");
  public maxZaiForm: FormControl = new FormControl("");
  public minStockDaysForm: FormControl = new FormControl("");
  public maxStockDaysForm: FormControl = new FormControl("");
  public dateBeginForm: FormControl = new FormControl(null);
  public dateEndForm: FormControl = new FormControl(null);

  public minZaiFormErr: boolean = false;
  public maxZaiFormErr: boolean = false;
  public minStockDaysFormErr: boolean = false;
  public maxStockDaysFormErr: boolean = false;

  public isCopyAllForm: FormControl = new FormControl(false);

  private keypadTargetId: string;

  /*
  public errorInputMessages: String[];
  */
  public errorSetAllMessages: String[] = [];

  @ViewChild("sectionItemsHeader", { static: true }) sectionItems: SectionHeaderComponent;
  @ViewChild(MatPaginator, { static: false }) matPaginator: MatPaginator;
  @ViewChild(NumberKeypadComponent, { static: false }) numberKeypadComponent: NumberKeypadComponent;

  private subsc: Subscription[] = [];

  constructor(
    public commonService: CommonService,
    private fb: FormBuilder,
    private fbOrigin: FormBuilder,
    private httpBasic: HttpBasicService
  ) {
    this.orderStopFlagValues = [];
    let flagList = this.commonService.getOrderStopSearchCondList();
    for (let i = 0; i < flagList.length; i++) {
      let flag = flagList[i];
      if (!flag.paramEditable) continue;
      // if (!flag.isAutoOrder) continue;
      if (flag.caseItem) continue;
      this.orderStopFlagValues.push(flag.value);
    }

    let maxLevel = this.commonService.config.maxCtgLevel;
    if (maxLevel > 0) this.displayColumnIds.push("ctg0");
    if (maxLevel > 1) this.displayColumnIds.push("ctg1");
    if (maxLevel > 2) this.displayColumnIds.push("ctg2");
    if (maxLevel > 3) this.displayColumnIds.push("ctg3");

    this.minDate = this.commonService.getToday();
  }

  ngOnInit() {
    this.commonService.pageTitle = this.commonService.pageMenuName;
    this.orderStopSelList = this.commonService.getOrderStopSelectList();
    this.itemSelectSimpleCondition.itemSearchCondConfig = this.commonService.config.itemSearchCond?.allstoreparamitem;

    if (!this.commonService.config.paramItemLimitMinZaiEditable) this.minZaiForm.disable();
    if (!this.commonService.config.paramItemLimitMaxZaiEditable) this.maxZaiForm.disable();
    if (!this.commonService.config.paramItemLimitMinStockDaysEditable) this.minStockDaysForm.disable();
    if (!this.commonService.config.paramItemLimitMaxStockDaysEditable) this.maxStockDaysForm.disable();

    this.subsc.push(this.formStoreGroupType.valueChanges.subscribe((val) => { this.getStoreGroupNames(); } ));
    this.subsc.push(this.formStoreGroupName.valueChanges.subscribe((val) => { this.getStoreGroupStores(); } ));
    this.subsc.push(this.minZaiForm.valueChanges.subscribe((val) => { this.checkError(); } ));
    this.subsc.push(this.maxZaiForm.valueChanges.subscribe((val) => { this.checkError(); } ));
    this.subsc.push(this.minStockDaysForm.valueChanges.subscribe((val) => { this.checkError(); } ));
    this.subsc.push(this.maxStockDaysForm.valueChanges.subscribe((val) => { this.checkError(); } ));
    this.subsc.push(this.dateBeginForm.valueChanges.subscribe(() => { this.dateCheck("begin"); } ));
    this.subsc.push(this.dateEndForm.valueChanges.subscribe(() => { this.dateCheck("end"); } ));

    this.getStoreGroupTypes();
  }

  ngOnDestroy() {
    this.subsc.forEach((subsc) => subsc.unsubscribe());
    this.itemList?.forEach((rec) => rec.cleanupEdit());
  }

  @HostListener('window:resize', ['$event'])
  handleResize() {
    this.setTableHeight();
  }

  setTableHeight() {
    setTimeout(() => { this.setTableHeightBody(); }, 0);
  }

  setTableHeightBody() {
    let id = "limit-param-items-table";
    let remHeight = this.commonService.getHeightBelow(id);
    if (remHeight == undefined) return;
    let paginatorHeight = 0;      // 56;
    let margin = 10 + 5;
    let btnBox = 24;
    let height = remHeight - paginatorHeight - margin - btnBox;
    if (height < 295 - paginatorHeight) height = 295 - paginatorHeight;

    let elem = document.getElementById(id);
    if (elem == undefined) return;
    if (elem) elem.style.maxHeight = "" + height + "px";
  }


  getStoreGroupTypes() {
    let ref = this.commonService.openSpinnerForSubComp(this.commonService.pageTitle, "初期化中・・・");
    let subsc = this.httpBasic.getStoreGroupType().subscribe(
      (response: RspGetStoreGroupType) => {
        subsc.unsubscribe();
        this.commonService.closeSpinnerForSubComp(ref);
        this.receiveStoreGroupType(response);
      },
      (error) => {
        subsc.unsubscribe();
        this.commonService.closeSpinnerForSubComp(ref);
        this.httpBasic.handleError(error);
      }
    );
  }

  receiveStoreGroupType(response: RspGetStoreGroupType) {
    if (this.httpBasic.handleAppError(response)) return;

    this.storeGroupTypes = [];
    for (let type of response.storeGroupTypes) {
      let typeRec = new StoreGroupTypeRec();
      typeRec.storeGroupTypeCd = type.storeGroupTypeCdFn;
      typeRec.storeGroupType = type.storeGroupTypeFv;
      this.storeGroupTypes.push(typeRec);
    }
  }

  getStoreGroupNames() {
    this.formStoreGroupName.setValue("");
    this.storeGroupNames = [];
    if (this.formStoreGroupType.value === "") return;
    let ref = this.commonService.openSpinnerForSubComp(this.commonService.pageTitle, "検索中・・・");
    let subsc = this.httpBasic.getStoreGroupName(this.formStoreGroupType.value).subscribe(
      (response: RspGetStoreGroupName) => {
        subsc.unsubscribe();
        this.commonService.closeSpinnerForSubComp(ref);
        this.receiveStoreGroupName(response);
      },
      (error) => {
        subsc.unsubscribe();
        this.commonService.closeSpinnerForSubComp(ref);
        this.httpBasic.handleError(error);
      }
    );
  }

  receiveStoreGroupName(response: RspGetStoreGroupName) {
    this.storeGroupNames = [];
    for (let type of response.storeGroupNames) {
      let nameRec = new StoreGroupNameRec();
      nameRec.storeGroupTypeCd = type.storeGroupTypeCdFn;
      nameRec.storeGroupCd = type.storeGroupCdFn;
      nameRec.storeGroupName = type.storeGroupNameFv;
      this.storeGroupNames.push(nameRec);
    }
  }

  getStoreGroupStores() {
    this.storeGroupStores = undefined;
    if (this.formStoreGroupName.value === "") {
      this.filterItemList();
      return;
    };

    let request: ReqGetStoreGroupStores = {
      access:             this.commonService.loginUser,
      storeGroupTypeCd:   parseInt(this.formStoreGroupType.value),
      storeGroupCd:       parseInt(this.formStoreGroupName.value),
    };

    let ref = this.commonService.openSpinnerForSubComp(this.commonService.pageTitle, "検索中・・・");
    let subsc = this.httpBasic.generalRequest("GetStoreGroupStore", request).subscribe(
      (response: RspGetStoreGroupStores) => {
        subsc.unsubscribe();
        this.commonService.closeSpinnerForSubComp(ref);
        this.receiveStoreGroupStores(response);
      },
      (error) => {
        subsc.unsubscribe();
        this.commonService.closeSpinnerForSubComp(ref);
        this.httpBasic.handleError(error);
      }
    );
  }

  receiveStoreGroupStores(response: RspGetStoreGroupStores) {
    if (this.httpBasic.handleAppError(response)) return;

    this.storeGroupStores = [];
    response.storeGroupStores.forEach((dto) => {
      let rec = new StoreGroupStoreRec();
      rec.storeGroupTypeCd = dto.storeGroupTypeCd;
      rec.storeGroupCd = dto.storeGroupCd;
      rec.storeCd = dto.storeCd;
      rec.storeName = dto.storeName;
      this.storeGroupStores.push(dto);
    });

    this.filterItemList();
  }

  doQuery() {
    let deactivate = this.canDeactivate();
    if (deactivate == true) {
      this.doQueryBody();
      this.itemSelected = undefined;
      this.sectionItems.openSectionBody();
      return;
    }
    let subsc = (deactivate as Observable<boolean>).subscribe(
      (data) => {
        subsc.unsubscribe();
        if (data == true) {
          this.doQueryBody();
          this.itemSelected = undefined;
          this.sectionItems.openSectionBody();
          return;
        }
      }
    );
  }

  doQueryBody() {
    let itemSelectSimpleCoditionForm: FormGroup = this.itemSelectSimpleCondition.formGroup;
    let categorySearchCondition: FormGroup = this.itemSelectSimpleCondition.ctgSelectCondition.formGroup;
    // let stopFlags = this.commonService.config.orderStopFlag.filter((item) => item.isAutoOrder).map((item) => item.value);
    let request: ReqGetItemLimitParamListRec = {
      access: { ...this.commonService.loginUser },
      itemSimpleSeachCondition: {
        storeCdFv: itemSelectSimpleCoditionForm.get('storeCd').value,
        ctgCd0Fv: categorySearchCondition.get('ctgLevel').value >= 0 ?
          categorySearchCondition.get('ctgCd0').value : '',
        ctgCd1Fv: categorySearchCondition.get('ctgLevel').value >= 1 ?
          categorySearchCondition.get('ctgCd1').value : '',
        ctgCd2Fv: categorySearchCondition.get('ctgLevel').value >= 2 ?
          categorySearchCondition.get('ctgCd2').value : '',
        ctgCd3Fv: categorySearchCondition.get('ctgLevel').value >= 3 ?
          categorySearchCondition.get('ctgCd3').value : '',
        itemCdFv: itemSelectSimpleCoditionForm.get('itemCode').value,
        itemNameFv: itemSelectSimpleCoditionForm.get('itemName').value,
        orderStopFlags: this.orderStopFlagValues,
        withoutCase: true
      },
      maxRows: 5001,
      onlyLimitParamItem: this.formOnlyLimitParamItem.value
    };

    this.commonService.openSpinner(this.commonService.pageTitle, "検索中・・・");
    let subsc = this.httpBasic.generalRequest("GetItemLimitParamListRec", request).subscribe(
      (response: RspGetItemLimitParamListRec) => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.receiveQuery(response);
      },
      error => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.httpBasic.handleError(error);
      }
    );
  }

  receiveQuery(response: RspGetItemLimitParamListRec) {
    if (this.httpBasic.handleAppError(response)) return;

    this.itemLimitParamList = [];
    this.clearMap();

    let cnt = 0;
    for (let dto of response.rows) {
      cnt++;
      if (cnt > 5000) {
        this.commonService.openNotificationDialog(this.commonService.pageTitle, `5000件を超える商品が検索されました。最初の5000件のみが処理対象となります。`);
        break;
      }
      let rec = new ItemLimitParamListRec(this.commonService);
      rec.initByDto(dto);
      this.itemLimitParamList.push(rec);
    }

    // this.filterListItems();
    this.recordCount = this.itemLimitParamList.length;
    this.matPaginator.pageIndex = 0;
    this.pageChanged(null);
  }

  pageChanged(event: PageEvent) {
    this.itemLimitParamListShow = [];
    let start =  this.matPaginator.pageIndex * this.matPaginator.pageSize;
    let end = start + this.matPaginator.pageSize;

    for (let i = start; i < end && i < this.recordCount; i++) {
      this.itemLimitParamListShow.push(this.itemLimitParamList[i]);
    }

    document.getElementById("item-list-container")?.scrollTo(0, 0);
  }

  delete(item: ItemLimitParamListRec) {
    if (item == this.itemSelected && this.changeMap.size > 0) {
      let subsc = this.commonService.openYesNoDialog(this.commonService.pageTitle, "変更が保存されていません。変更内容を破棄しますか？").subscribe(
        (response: boolean) => {
          subsc.unsubscribe();
          if (response) {
            this.itemSelected = undefined;
            this.itemList.forEach((rec) => rec.cleanupEdit());
            this.itemList = undefined;
            this.itemListFiltered = undefined;
            this.clearMap();
            this.deleteBody(item);
          }
        }
      );
    } else {
      if (item == this.itemSelected) {
        this.itemSelected = undefined;
        this.itemList.forEach((rec) => rec.cleanupEdit());
        this.itemList = undefined;
        this.itemListFiltered = undefined;
        this.clearMap();
      }
      this.deleteBody(item);
    }
  }

  deleteBody(item: ItemLimitParamListRec) {
    item.limitParamCnt = 0;

    let request: ReqDeleteItemLimitParamRec = {
      access: this.commonService.loginUser,
      itemCd: item.itemCd
    };

    this.commonService.openSpinner(this.commonService.pageTitle, "削除中・・・");
    let subsc = this.httpBasic.generalRequest("DeleteItemLimitParamRec", request).subscribe(
      (response: RspDeleteItemLimitParamRec) => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.receiveDelete(response);
      },
      error => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.httpBasic.handleError(error);
      }
    );
  }

  receiveDelete(response: RspDeleteItemLimitParamRec) {
    if (this.httpBasic.handleAppError(response)) return;
  }

  clickItem(item: ItemLimitParamListRec) {
    if (this.itemSelected == item) {
      this.sectionItems.closeSectionBody();
      return;
    }
    let deactivate = this.canDeactivate();
    if (deactivate == true) {
      this.clickItemBody(item);
      return;
    }
    let subsc = (deactivate as Observable<boolean>).subscribe(
      (data) => {
        subsc.unsubscribe();
        if (data == true) {
          this.clickItemBody(item);
          return;
        }
      }
    );
  }

  clickItemBody(item: ItemLimitParamListRec) {
    this.itemSelected = item;
    this.sectionItems.closeSectionBody();
    this.clearMap();

    let request: ReqGetItemLimitParamRec = {
      access: this.commonService.loginUser,
      itemCd: item.itemCd
    };

    this.commonService.openSpinner(this.commonService.pageTitle, "検索中・・・");
    let subsc = this.httpBasic.generalRequest("GetItemLimitParamRec", request).subscribe(
      (response: RspGetItemLimitParamRec) => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.receiveClickItemBody(response);
      },
      error => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.httpBasic.handleError(error);
      }
    );
  }

  receiveClickItemBody(response: RspGetItemLimitParamRec) {
    if (this.httpBasic.handleAppError(response)) return;

    this.itemList = [];
    for (let dto of response.rows) {
      let rec: ItemLimitParamRec = new ItemLimitParamRec(this.commonService);
      rec.initByDto(dto);
      rec.prepareEdit();
      rec.setChangeListener(this.changeListener.bind(this));
      this.itemList.push(rec);
    }
    this.itemList.sort((a, b) => {
      let aa = this.commonService.zeroPadding(a, 10);
      let bb = this.commonService.zeroPadding(b, 10);
      if (aa < bb) return(-1);
      if (aa > bb) return(1);
      return 0;
    });

    this.filterItemList();
    this.setTableHeight();
  }

  filterItemList() {
    if (!this.storeGroupStores) {
      this.itemListFiltered = [...this.itemList];
    } else {
      this.itemListFiltered = this.itemList.filter((rec) => this.storeGroupStores.find((item) => item.storeCd === rec.storeCd));
    }
    this.itemListRecordCount = this.itemListFiltered.length;
    this.clearMap();
    this.itemListFiltered.forEach((rec) => this.changeListener(rec));
  }

  clearMap() {
    this.changeMap.clear();
    this.updMap.clear();
    this.errorMap.clear();
  }

  changeListener(item: ItemLimitParamRec) {
    if (this.changeMap.has(item.storeCd)) {
      if (!item.edit.isDirty) {
        this.changeMap.delete(item.storeCd);
      }
    } else {
      if (item.edit.isDirty) {
        this.changeMap.set(item.storeCd, item);
      }
    }
    if (this.updMap.has(item.storeCd)) {
      if (!item.edit.updRequired) {
        this.updMap.delete(item.storeCd);
      }
    } else {
      if (item.edit.updRequired) {
        this.updMap.set(item.storeCd, item);
      }
    }
    if (this.errorMap.has(item.storeCd)) {
      if (!item.edit.isError) {
        this.errorMap.delete(item.storeCd);
      }
    } else {
      if (item.edit.isError) {
        this.errorMap.set(item.storeCd, item);
      }
    }
  }

  dateCheck(which: string) {
    let begin: Date = this.dateBeginForm.value;
    let end: Date = this.dateEndForm.value;
    if (begin !== null && end !== null) {
      if (begin.getTime() > end.getTime()) {
        if (which === "begin") {
          this.dateEndForm.setValue(this.commonService.copyDate(begin), {emitEvent: false});
        } else {
          this.dateBeginForm.setValue(this.commonService.copyDate(end), {emitEvent: false});
        }
      }
    }
  }

  doSetAll() {
    if (this.isCopyAllForm.value) {
      this.doSetAllWithCleanup();
    } else {
      this.doSetAllWithoutCleanup();
    }
  }

  doSetAllWithCleanup() {
    this.itemListFiltered.forEach((rec) => {
      if (!rec.edit.minZaiLim.disabled) rec.edit.minZaiLim.setValue(this.minZaiForm.value);
      if (!rec.edit.maxZaiLim.disabled) rec.edit.maxZaiLim.setValue(this.maxZaiForm.value);
      if (!rec.edit.minStockDaysLim.disabled) rec.edit.minStockDaysLim.setValue(this.minStockDaysForm.value);
      if (!rec.edit.maxStockDaysLim.disabled) rec.edit.maxStockDaysLim.setValue(this.maxStockDaysForm.value);
      let begin = this.dateBeginForm.value;
      if (begin) begin = this.commonService.copyDate(begin);
      if (!rec.edit.dateBegin.disabled) rec.edit.dateBegin.setValue(begin);
      let end = this.dateEndForm.value;
      if (end) end = this.commonService.copyDate(end);
      if (!rec.edit.dateEnd.disabled) rec.edit.dateEnd.setValue(end);
    });
  }

  doSetAllWithoutCleanup() {
    this.itemListFiltered.forEach((rec) => {
      if (!rec.edit.minZaiLim.disabled && this.minZaiForm.value !== "") rec.edit.minZaiLim.setValue(this.minZaiForm.value);
      if (!rec.edit.maxZaiLim.disabled && this.maxZaiForm.value !== "") rec.edit.maxZaiLim.setValue(this.maxZaiForm.value);
      if (!rec.edit.minStockDaysLim.disabled && this.minStockDaysForm.value !== "") rec.edit.minStockDaysLim.setValue(this.minStockDaysForm.value);
      if (!rec.edit.maxStockDaysLim.disabled && this.maxStockDaysForm.value !== "") rec.edit.maxStockDaysLim.setValue(this.maxStockDaysForm.value);
      if (!rec.edit.dateBegin.disabled && this.dateBeginForm.value !== null) {
        let begin = this.commonService.copyDate(this.dateBeginForm.value);
        rec.edit.dateBegin.setValue(begin);
      }
      if (!rec.edit.dateEnd.disabled && this.dateEndForm.value !== null) {
        let end = this.commonService.copyDate(this.dateEndForm.value);
        rec.edit.dateEnd.setValue(end);
      }
    });
  }

  doClearFormSetAll() {
    this.minZaiForm.setValue("");
    this.maxZaiForm.setValue("");
    this.minStockDaysForm.setValue("");
    this.maxStockDaysForm.setValue("");
    this.minZaiFormErr = false
    this.maxZaiFormErr = false
    this.minStockDaysFormErr = false
    this.maxStockDaysFormErr = false
    this.errorSetAllMessages = [];
  }

  isDelRec(rec: ItemLimitParamRec) {
    if (rec.edit.minZaiLim.value !== "") return false;
    if (rec.edit.maxZaiLim.value !== "") return false;
    if (rec.edit.minStockDaysLim.value !== "") return false;
    if (rec.edit.maxStockDaysLim.value !== "") return false;
    if (rec.dateBegin === "") return false;
    return true;
  }

  doUpdate() {
    let request: ReqUpdateItemLimitParamRec = {
      access: this.commonService.loginUser,
      upds: [],
      dels: []
    };

    this.updMap.forEach((rec) => {
      let dto: UpdateItemLimitParamRecDto = {
        storeCd:		  rec.storeCd,
        itemCd:			  rec.itemCd,
        minZai:			  rec.edit.minZaiLim.value === "" ? rec.getValue("minZai") : parseInt(rec.edit.minZaiLim.value),
        maxZai:			  rec.edit.maxZaiLim.value === "" ? rec.getValue("maxZai") : parseInt(rec.edit.maxZaiLim.value),
        minStockDays: rec.edit.minStockDaysLim.value === "" ? rec.getValue("minStockDays") : parseInt(rec.edit.minStockDaysLim.value),
        maxStockDays:	rec.edit.maxStockDaysLim.value === "" ? rec.getValue("maxStockDays") : parseInt(rec.edit.maxStockDaysLim.value),
        dateBegin:		this.commonService.formatDate(rec.edit.dateBegin.value),
        dateEnd:		  this.commonService.formatDate(rec.edit.dateEnd.value)
      };

      if (this.isDelRec(rec)) {
        request.dels.push(dto);
      } else {
        request.upds.push(dto);
      }
    });

    this.commonService.openSpinner(this.commonService.pageTitle, "登録中・・・");
    let subsc = this.httpBasic.generalRequest("UpdateItemLimitParamRec", request).subscribe(
      (response: RspUpdateItemLimitParamRec) => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.receiveDoUpdate(response);
      },
      error => {
        this.commonService.closeSpinner();
        subsc.unsubscribe();
        this.httpBasic.handleError(error);
      }
    );
  }

  receiveDoUpdate(response: RspUpdateItemLimitParamRec) {
    if (this.httpBasic.handleAppError(response)) return;

    this.updMap.forEach((rec) => {
      if (this.isDelRec(rec)) {
        rec.minZaiLim = 0;
        rec.maxZaiLim = 0;
        rec.minStockDaysLim = 0;
        rec.maxStockDaysLim =	0;
        rec.dateBegin =	"";
        rec.dateEnd = "";
      } else {
        rec.minZaiLim = rec.edit.minZaiLim.value === "" ? rec.getValue("minZai") : parseInt(rec.edit.minZaiLim.value);
        rec.maxZaiLim = rec.edit.maxZaiLim.value === "" ? rec.getValue("maxZai") : parseInt(rec.edit.maxZaiLim.value);
        rec.minStockDaysLim = rec.edit.minStockDaysLim.value === "" ? rec.getValue("minStockDays") : parseInt(rec.edit.minStockDaysLim.value);
        rec.maxStockDaysLim =	rec.edit.maxStockDaysLim.value === "" ? rec.getValue("maxStockDays") : parseInt(rec.edit.maxStockDaysLim.value);
        rec.dateBegin =	this.commonService.formatDate(rec.edit.dateBegin.value);
        rec.dateEnd = this.commonService.formatDate(rec.edit.dateEnd.value);
      }
      rec.cleanupEdit();
      rec.prepareEdit();
    });
    this.clearMap();
    this.itemSelected.limitParamCnt = this.itemList.filter((rec) => rec.dateBegin !== "").length;
  }

  checkError() {
    this.minZaiFormErr = false
    this.maxZaiFormErr = false
    this.minStockDaysFormErr = false
    this.maxStockDaysFormErr = false
    this.errorSetAllMessages = [];
    this.checkRange();
    this.checkMinMax();
  }

  checkRange() {
    let config = this.commonService.config;
    if (this.minZaiForm.value !== "" && config.paramItemLimitMinZaiRange) {
      let value = parseInt(this.minZaiForm.value);
      let min = config.paramItemLimitMinZaiRange.min;
      let max = config.paramItemLimitMinZaiRange.max;
      if (value < min || value > max) {
        this.minZaiFormErr = true;
        this.errorSetAllMessages.push("最低陳列の値は、" + min + "～" + max + "の範囲でなければなりません。");
      }
    }
    if (this.maxZaiForm.value !== "" && config.paramItemLimitMaxZaiRange) {
      let value = parseInt(this.maxZaiForm.value);
      let min = config.paramItemLimitMaxZaiRange.min;
      let max = config.paramItemLimitMaxZaiRange.max;
      if (value < min || value > max) {
        this.maxZaiFormErr = true;
        this.errorSetAllMessages.push("最大陳列の値は、" + min + "～" + max + "の範囲でなければなりません。");
      }
    }
    if (this.minStockDaysForm.value !== "" && config.paramItemLimitMinStockDaysRange) {
      let value = parseInt(this.minStockDaysForm.value);
      let min = config.paramItemLimitMinStockDaysRange.min;
      let max = config.paramItemLimitMinStockDaysRange.max;
      if (value < min || value > max) {
        this.minStockDaysFormErr = true;
        this.errorSetAllMessages.push("最低在庫日数の値は、" + min + "～" + max + "の範囲でなければなりません。");
      }
    }
    if (this.maxStockDaysForm.value !== "" && config.paramItemLimitMaxStockDaysRange) {
      let value = parseInt(this.maxStockDaysForm.value);
      let min = config.paramItemLimitMaxStockDaysRange.min;
      let max = config.paramItemLimitMaxStockDaysRange.max;
      if (value < min || value > max) {
        this.maxStockDaysFormErr = true;
        this.errorSetAllMessages.push("最大在庫日数の値は、" + min + "～" + max + "の範囲でなければなりません。");
      }
    }
  }

  checkMinMax() {
    var minValue: number;
    var maxValue: number;

    if (this.minZaiForm.value !== "" && this.maxZaiForm.value !== "") {
      minValue = parseInt(this.minZaiForm.value);
      maxValue = parseInt(this.maxZaiForm.value);
      if (minValue > maxValue) {
        this.minZaiFormErr = true;
        this.maxZaiFormErr = true;
        this.errorSetAllMessages.push("最低陳列と最大陳列の大小関係が逆転しています。")
      }
    }

    if (this.minStockDaysForm.value !== "" && this.maxStockDaysForm.value !== "") {
      minValue = parseInt(this.minStockDaysForm.value);
      maxValue = parseInt(this.maxStockDaysForm.value);
      if (minValue > maxValue) {
        this.minStockDaysFormErr = true;
        this.maxStockDaysFormErr = true;
        this.errorSetAllMessages.push("最低在庫日数と最大在庫日数の大小関係が逆転しています。")
      }
    }
  }

  doCancel() {
    this.itemList.forEach((rec) => rec.cancelEdit());
    this.clearMap();
  }

  use10KeyPad() {
    return this.commonService.config.use10KeyPad;
  }

  is10KeyPadTarget(id: string) {
    if (!this.use10KeyPad()) return false;
    if (id === this.keypadTargetId) return true;
    return false;
  }

  set10KeyPadTarget(id: string, form: FormControl) {
    this.clearKeypadTargetId();
    if (id == "minZaiForm" && !this.commonService.config.paramItemMinZaiEditable) return;
    if (id == "maxZaiForm" && !this.commonService.config.paramItemMaxZaiEditable) return;
    if (id == "minStockDaysForm" && !this.commonService.config.paramItemMinStockDaysEditable) return;
    if (id == "maxStockDaysForm" && !this.commonService.config.paramItemMaxStockDaysEditable) return;

    for (let item of this.itemList) {
      if (id == "" + item.storeCd + "-minZai" && !this.commonService.config.paramItemMinZaiEditable) return;
      if (id == "" + item.storeCd + "-maxZai" && !this.commonService.config.paramItemMaxZaiEditable) return;
      if (id == "" + item.storeCd + "-minStockDays" && !this.commonService.config.paramItemMinStockDaysEditable) return;
      if (id == "" + item.storeCd + "-maxStockDays" && !this.commonService.config.paramItemMaxStockDaysEditable) return;
    }

    this.keypadTargetId = id;
    this.numberKeypadComponent.setTargetForm(form);
  }

  clearKeypadTargetId() {
    this.keypadTargetId = undefined;
    this.numberKeypadComponent.inputField = undefined;
  }

  isKeyboardLocked() {
    if (!this.use10KeyPad()) return null;
    if (this.numberKeypadComponent && this.numberKeypadComponent.isKeyboardLocked()) return true;
    return false;
  }

  canDeactivate() {
    if (this.changeMap.size === 0) { return true; }
    return this.commonService.openYesNoDialog(this.commonService.pageTitle, "変更が保存されていません。変更内容を破棄しますか？");
  }
}
